import http from "../../core/services/http.service";

const PreBidsService = {
  getPreBids(params = null) {
    return http.get(`/api/v1/pre-bids/`, {
      params: {
        ...params,
        expand: 'bidder.customer,bidder.preferred_clerk,bidder.language,lot,clerk'
      }
    });
  },
  updatePreBid(id, data, expand = '') {
    return http.put(`/api/v1/pre-bids/${id}/?expand=${expand}`, data);
  },
  createPreBid(data) {
    return http.post('/api/v1/pre-bids/', data);
  },
  batchConfirmation(data) {
    return http.patch('/api/v1/pre-bids/batch/confirmation/', data);
  },
  getPreBidsPdfData(params) {
    return http.get('/api/v1/pre-bids/pdf-data-clerk/', {params});
  },
  removeHistoryBid(uuid) {
    return http.delete(`/api/v1/pre-bids/history/${uuid}`)
  },
  createWinnerBidFromPreBid(uuid, data) {
    return http.post(`/api/v1/pre-bids/${uuid}/mark-as-winner/`, data)
  },
  generateAssignClerks(params = null) {
    const expand = 'bidder.customer,bidder.preferred_clerk,bidder.language,lot,clerk'
    return http.post(`/api/v1/pre-bids/assign/?expand=${expand}`, params);
  },
  batchUpdatePreBids(data) {
    return http.put(`/api/v1/pre-bids/`, data);
  },
};

export default PreBidsService;
